import { v4 as uuidv4 } from 'uuid';
import CertifAngularAdvImg from '../images/angularAvancado.png';
import AngularDevImg from '../images/avndAngularDev.png';
import ComplexFrontImg from '../images/complexFrontend.jpg';
import JavascriptEssencialImg from '../images/Javascript_Essencial.png';
import JscriptAvancadoImg from '../images/Jscript_Avancado.png';
import IntroReactImg from '../images/introReact.png';
import ComponentsReactImg from '../images/trabalhandoComponentesReactpng.png';

const certificates = [
  {
    id: uuidv4(),
    name: 'Introdução ao ReactJS',
    desc: 'Introdução ao ReactJS',
    img: IntroReactImg,
    source: 'https://www.dio.me/certificate/C3EF265A',
  },
  {
    id: uuidv4(),
    name: 'Trabalhando com Componentes em React',
    desc: 'Entendendo o uso de props e hooks no desenvolvimento de componentes',
    img: ComponentsReactImg,
    source: 'https://www.dio.me/certificate/8A535E1C',
  },
  {
    id: uuidv4(),
    name: 'ES6 Essencial',
    desc: 'JavaScript ES6 essencial',
    img: JavascriptEssencialImg,
    source: 'https://www.dio.me/certificate/6A5081A4/',
  },
  {
    id: uuidv4(),
    name: 'JavaScript ES6 Avançado',
    desc: 'Desenvolvimento avançado com JavaScript ES6',
    img: JscriptAvancadoImg,
    source: 'https://www.dio.me/certificate/020E93A3',
  },
  {
    id: uuidv4(),
    name: 'Arquitetura e gestão do front-end ',
    desc: 'A arquitetura de componentes e a gestão do front-end com Angular',
    img: ComplexFrontImg,
    source: 'https://www.dio.me/certificate/CA3E90A0',
  },
  {
    id: uuidv4(),
    name: 'Avanade Angular Developer',
    desc: 'Bootcamp Angular Developer - Avanade',
    img: AngularDevImg,
    source: 'https://www.dio.me/certificate/1269F249',
  },
  {
    id: uuidv4(),
    name: 'Performance e Otimização Angular',
    desc: 'Conceitos avançados de performance e otimização usando Angular',
    img: CertifAngularAdvImg,
    source: 'https://www.dio.me/certificate/A7EE8A2B',
  },
];

export default certificates;
